<template>
<div class="footer-area white-color" style="background: #333;">
  <div class="container">
    <el-row>
      <el-col :span="5">
        <div class="title">联系我们</div>
        <ul>
          <li>电话：17610705607</li>
          <li>邮箱：fww@fanwuwang.com</li>
          <li>研发中心：北京市合众思壮北斗产业园2号楼510室</li>
          <li>公司地址：河南省郑州市二七区航海路与嵩山路交叉口东方大厦B座27楼2706-6号</li>
          </ul>
      </el-col>
      <el-col :span="5">
        <div class="title">产品中心</div>
        <ul>
          <li @click='goProduct(1)'>泛物网络售电支持平台</li>
          <li @click='goProduct(2)'>泛物网络数据监控平台</li>
          <li @click='goProduct(3)'>泛物网络物联网中心平台</li>
          <li @click='goProduct(4)'>泛物网络城市供水管网检测平台</li>
        </ul>
      </el-col>
      <el-col :span="5">
        <div class="title">解决方案</div>
        <ul>
          <li @click='goSolution(1)'>泛物网络售电支持平台解决方案</li>
          <li @click='goSolution(2)'>泛物网络数据监控平台解决方案</li>
          <li @click='goSolution(3)'>泛物网络物联网中心平台解决方案</li>
          <li @click='goSolution(4)'>泛物网络城市供水管网检测平台解决方案</li>
        </ul>
      </el-col>
      <el-col :span="5">
        <div class="title">泛物网络</div>
        <ul>
          <li @click='goFanwu(1)'>平台优势</li>
          <li @click='goFanwu(2)'>设备管理</li>
          <li @click='goFanwu(3)'>可视化展示</li>
          <li @click='goFanwu(4)'>数据分析</li>
          </ul>
      </el-col>
      <el-col :span="4">
        <div class="title">公众号</div>
        <div class="QRcode">
          <img src="../../../static/img/WeChatCode.png" alt="" >
          <div class="name">泛物网络</div>
        </div>
      </el-col>
    </el-row>
  </div>
  <div class="row" style="margin-top: 10px;">
    <div class="copyright text-left" style="color: #c3cde6;">
      <div style="width: 80%;margin: 0 auto; font-size: 14px;">
		<sapn style="color: #adadad;">Copyright © 2020 - 2030 河南省泛物网络科技有限公司 版权所有</sapn>
        <a class="Underline" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="color: #adadad;">豫ICP备20015125号</a>
        <span style="height: 14px;width: 2px;background-color: #3f496b;display: inline-block; margin: 0 10px;"> </span>
        <a class="Underline" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41092802000225" style="color:#adadad;">
          <img style="vertical-align:top;" src="../../../static/img/jinghui.png" alt="">
          豫公网安备 41092802000225号
        </a>
        <span style="height: 14px;width: 2px;background-color: #3f496b;display: inline-block; margin: 0 10px;"> </span>
         <router-link to="Statement"><a class="Underline" href="#javascript::" target="_blank" style="color: #adadad;">免责声明</a></router-link>
      </div>
    </div>
  </div>

<!-- 联系我们 -->
 <div v-if="btnis" @click="goto('aboutus','productId')" class="Conbtn" style="position: fixed;width: 200px;height: 50px;bottom: 40px;right: 40px;color: #fff;
    background-color: #393bc2;line-height: 50px;border-radius: 5px;text-align: center;font-size: 20px;z-index: 10;cursor:pointer;"> <i class="el-icon-chat-line-round" style="margin-right: 10px;;"></i>联系我们</div>
</div>

</template>

<script>
export default {
    data() {
      return {
        btnis:true
      }
    },
    created(){
        if(this.$route.path=='/aboutus'){
            this.btnis = false
        }
    },
  methods:{
    // 联系我们跳转
    goto(page,selectId){
      var path = page;
      var selectId = selectId;
      localStorage.setItem("toId",selectId);
      this.$router.push({name: path, query: {info:true}});
    },
    // 产品中心
    goProduct(is){
      // 判断跳转商品内页
        if(this.$route.name=='Product'){
          this.$router.replace({
              path: '/refresh?tid='+is,
          })
        }else{
          this.$router.push({name:'Product', query: {tid:is}});
        }
    },
    // 解决方案
    goSolution(Jump){
        if(this.$route.name=='Information'){
         this.$router.replace({
             path: '/refresh?tid='+Jump,
         })
        }else{
          this.$router.push({name:'Information', query: {tid:Jump}});
        }
    },
    // 泛物网络
    goFanwu(Jump){
        if(this.$route.name=='Platform'){
         this.$router.replace({
             path: '/refresh?tid='+Jump,
         })
        }else{
          this.$router.push({name:'Platform', query: {tid:Jump}});
        }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  *{
    font-family: 'Microsoft YaHei';
  }
  .container{
        color: #adadad;
        padding: 20px 0 10px;
    .el-row{

      .el-col{
        .title{
          padding: 10px 0;
          font-size: 20px;
          position: relative;
          &::before{
            position: absolute;
            bottom: 0;
            content: "";
            height: 2px;
            width: 100%;
            background-color: #444;
          }
        }
        ul{
          padding: 24px 0;
          li{
           cursor: pointer;
            font-size: 13px;
                line-height: 24px;
                &:hover{
                  color: #999;
                }
          }
        }
        .QRcode{

          width: 40%;
          img{
            width: 100%;
            margin: 10px 0;
          }
          .name{
            font-size: 14px;
            text-align: center;
          }
        }
      }
      .el-col:first-child ul li{
        cursor: default;
        &:hover{
          color: #adadad;
        }
      }
    }
  }


  .Underline{

  }
  .Underline::before{
    content: "";
        width: 1px;
        height: 14px;
        background: #3f496b;
  }
  .Underline:hover{
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Footer.vue